import SettingBase from '../settings/util/SettingBase'

class ItemController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state
    this.id = "items"
    this.acl = {}
    this.hasACL = {}

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-' + this.id]) {
      this.hasACL[this.acl['setting-' + this.id][key]] = true;
    }
  }
}

export default ItemController;


// WEBPACK FOOTER //
// ./client/app/components/item/item.controller.js